module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-17.fae529dd.svg";